"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumns = void 0;
require("@veeam/components");
const constants_1 = require("../../../..//constants");
const components_1 = require("../../../../components");
const policyNameCellRenderer_1 = require("../cellRenderers/policyNameCellRenderer");
const constants_2 = require("../constants");
require("../types");
const getColumns = (texts) => [
    {
        id: constants_2.ADD_TO_POLICY_DIALOG_COLUMNS.name,
        sortKey: constants_2.ADD_TO_POLICY_DIALOG_COLUMNS.name,
        title: texts.policyNameTitle,
        cell: components_1.cellRendererAdapter(constants_2.ADD_TO_POLICY_DIALOG_COLUMNS.name, policyNameCellRenderer_1.policyNameCellRenderer()),
    },
    {
        id: constants_2.ADD_TO_POLICY_DIALOG_COLUMNS.description,
        sortKey: constants_2.ADD_TO_POLICY_DIALOG_COLUMNS.description,
        title: texts.policyDescriptionTitle,
        cell: (data) => data.description || constants_1.EMPTY_TEXT.dash,
        width: 220,
    },
];
exports.getColumns = getColumns;
//# sourceMappingURL=getColumns.js.map